"use strict";
import { config } from "./../config";
import axios from 'axios';

export const equService = {
    getEquipos,
    generarEquipo,
    registrarEquipo
}

async function getEquipos() {
    const res = await axios.get(`${config.api_url}/equipos`)
    return res.data
}

async function generarEquipo(equipo) {

    const res = await axios.post(`${config.api_url}/equipo`,JSON.stringify(equipo), {
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    return res.data
}

async function registrarEquipo(data) {
    const res = await axios.post(`${config.api_url}/equipo/registro`,JSON.stringify(data), {
        headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache"
        }
    })
    return res.data
}